import { RouteLocationNormalized } from "vue-router";

const BeforeEach = (to: RouteLocationNormalized): void => {
  if (to.meta.title) {
    SetTitle(to.meta.title as string);
  }
};

const SetTitle = (title: string) => {
  document.title = title;
};

export default {
  BeforeEach,
};
